// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selected-region[data-v-5eaa7b3c] {\n    background-color: red; /* Change this to the desired highlight color */\n}\n", ""]);
// Exports
module.exports = exports;
